import { Link } from 'react-router-dom'
import { FileText } from 'lucide-react'
import { useAuth } from '../hooks';
import { supabase } from '../lib/util';

const NavBar = () => {


  const { user: userData = {}, isAuthenticated = false } = useAuth();

  const handleLogOut = async () => {
    try {
      const { error } = await supabase.auth.signOut()
      if (error) throw error
    } catch (error) {
      console.log(error)
    }

  }

  const { email = '', user_metadata: { avatar_url: avatarUrl = '' } = {} } = userData;

  return (
    <nav className="relative z-10">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-6">
          <Link to="/" className="flex items-center space-x-2">
            <FileText className="h-6 w-6" />
            <span className="text-xl font-semibold">ResumeCraftr</span>
          </Link>
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/select-template" className="text-sm text-gray-600 hover:text-gray-900">Templates</Link>
            {/* <Link to="#features" className="text-sm text-gray-600 hover:text-gray-900">Features</Link> */}
            {/* <Link to="#pricing" className="text-sm text-gray-600 hover:text-gray-900">Pricing</Link> */}
            {/* <Link to="#blog" className="text-sm text-gray-600 hover:text-gray-900">Blog</Link> */}

            {/* <Link to="/signup">
                <button className="rounded-full bg-white py-2 px-6 text-sm font-semibold">Sign up</button>
              </Link> */}

            {isAuthenticated ? (
              <div className="relative group flex items-center">

                {avatarUrl ? (
                  <img
                    src={avatarUrl}
                    alt="avatar"
                    className="h-8 w-8 rounded-full"
                  />
                ) : (
                  <div className="bg-muted-foreground text-white font-semibold rounded-full w-10 h-10 flex justify-center items-center">
                    {email?.[0]?.toUpperCase()}
                  </div>
                )}

                  <div className="absolute right-0 top-11 w-44 opacity-0 invisible group-hover:visible group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-200">
      
      <div className="bg-white border border-gray-200 rounded-lg shadow-xl">

        <div className="px-3 py-1 text-xs text-gray-500 truncate">
          {email}
        </div>

        <div className="border-t border-gray-300 my-1"></div>

        <button
          onClick={handleLogOut}
          className="w-full text-left px-3 py-1 text-sm text-gray-600 hover:bg-gray-50 hover:text-gray-900 transition"
        >
          Log out
        </button>

      </div>

    </div>

                {/* <button
              onClick={handleLogOut}
              className="rounded-full bg-white py-2 px-4 text-sm font-semibold"
            >
              Log out
            </button> */}

              </div>
            ) : (
              <Link to="/signup">
                <button className="rounded-full bg-white py-2 px-6 text-sm font-semibold">
                  Sign up
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
    // <div className='flex justify-between items-center border-b px-3 py-4 fixed z-50 bg-white w-full'>
    //     <Link to='/' className='flex items-center'>
    //         <div className='text-2xl md:text-3xl'>
    //             <FaRegFileAlt />

    //         </div>
    //         <h1 className='text-lg md:text-2xl font-bold'>ResumeCraftr</h1>
    //     </Link>

    //     <div className='hidden list-none md:flex font-semibold'>
    //         <Link
    //             to="/select-template" className='mx-2'>
    //             Templates
    //         </Link>
    //         {/* <Link
    //             to="/pricing" className='mx-2'>
    //             Pricing
    //         </Link> */}

    //     </div>
    //     {
    //         isAuthenticated ? <div className=' hidden md:flex items-center'>

    //             <div className='mx-5'>
    //                 {avatarUrl ? <img src={avatarUrl} alt="" className='rounded-full h-10' /> : <div className='bg-muted-foreground text-white font-semibold rounded-full w-10 h-10 flex justify-center items-center'>{email[0].toUpperCase()}</div>}
    //             </div>

    //             <div onClick={handleLogOut} className='flex text-muted-foreground hover:text-foreground items-center mx-1'>
    //                 <button className='mr-2'>
    //                     Log Out
    //                 </button>
    //                 <FaArrowRight  size={15}/>
    //             </div>
    //         </div>
    //             : <div className='hidden md:flex items-center'>

    //                 <Link to='/signin'>
    //                     <div className='mx-2 font-semibold'>
    //                         Sign in
    //                     </div>
    //                 </Link>

    //                 <Link to="/signup" className='mx-2 bg-black text-white px-6 py-3 rounded-md text-sm flex items-center'>
    //                     <button className='mr-2'>
    //                         Get Started
    //                     </button>
    //                 </Link>
    //             </div>}

    //     <div className='md:hidden text-2xl z-50 right-0'>
    //         {isMenuOpen ? <FaXmark onClick={handleMenu} /> : <IoMenu onClick={handleMenu} />}
    //     </div>
    //     <div className={`md:hidden ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'} absolute left-0 top-0 transition-transform delay-150 duration-300 ease-in-out h-dvh flex shadow-xl w-full list-none font-semibold`}>
    //         <div className='flex flex-col justify-between w-[75%] bg-white px-2 py-4'>
    //             <div>
    //                 <div className='flex justify-between'>
    //                     {/* <div className='flex items-center'>
    //                         <div className='text-2xl md:text-3xl'>
    //                             <FaRegFileAlt />

    //                         </div>
    //                         <h1 className='text-lg md:text-2xl font-bold'>ResumeCraftr</h1>
    //                     </div> */}
    //                     <Link
    //                         to="/select-template"
    //                         className="flex items-center space-x-3 hover:bg-gray-100 transition-colors"
    //                     >
    //                         <MdOutlineInsertDriveFile className="h-7 w-7 text-blue-500" />
    //                         <span className="text-lg font-medium">Templates</span>
    //                     </Link>

    //                     {isAuthenticated &&
    //                         <div className='mr-3 ml-20'>
    //                             {avatarUrl ? <img src={avatarUrl} alt="" className='rounded-full h-10' /> : <div className='bg-muted-foreground text-white font-medium rounded-full w-10 h-10 flex justify-center items-center'>{email[0].toUpperCase()}</div>}
    //                         </div>
    //                     }
    //                 </div>


    //                 {/* <Link
    //                     to="/pricing"
    //                     className="flex items-center space-x-3 px-4 py-3 hover:bg-gray-100 transition-colors"
    //                 >
    //                     <TbReportMoney className="h-5 w-5 text-green-500" />
    //                     <span className="text-sm font-medium">Pricing</span>
    //                 </Link> */}

    //                 {!isAuthenticated && <Link
    //                     to="/signin"
    //                     className="flex items-center space-x-3 px-4 py-3 hover:bg-gray-100 transition-colors"
    //                 >
    //                     <IoMdLogIn className="h-5 w-5 text-purple-500" />
    //                     <span className="text-sm font-medium">Sign in</span>
    //                 </Link>}

    //             </div>
    //             <div>
    //                 {
    //                     isAuthenticated ? <div onClick={handleLogOut} className='cursor-pointer mx-2 bg-black text-white px-6 py-3 rounded-md text-sm flex justify-between items-center'>
    //                         <button className='mr-2'>
    //                             Log Out
    //                         </button>
    //                         <MdLogout color='grey' size={20} />


    //                     </div> :
    //                         <Link to="/signup" className=' mx-2 bg-black text-white px-6 py-3 rounded-md text-sm flex justify-between items-center'>
    //                             <button className='mr-2'>
    //                                 Get Started
    //                             </button>
    //                             <FaArrowRight color='grey' />

    //                         </Link>
    //                 }
    //             </div>
    //         </div>
    //         <div onClick={handleMenu} className='w-[25%] bg-black/45 h-full'>

    //         </div>
    //     </div>


    // </div>
  )
}

export default NavBar